import { render, staticRenderFns } from "./walking-customer-modal.vue?vue&type=template&id=0e4cb9f2&scoped=true&"
import script from "./walking-customer-modal.vue?vue&type=script&lang=js&"
export * from "./walking-customer-modal.vue?vue&type=script&lang=js&"
import style0 from "./walking-customer-modal.vue?vue&type=style&index=0&id=0e4cb9f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4cb9f2",
  null
  
)

export default component.exports